import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import styled from 'styled-components';
import IconButton from '../basics/IconButton';

const StyledMenu = styled(DropdownMenu)`
  overflow-y: scroll;
  max-height: 50vh;
  max-width: var(--side-panel-width);
  font-size: 0.9em;
`;

const DarkerTextButton = styled(IconButton)`
  color: var(--text-color);
`;

const DashboardViewsDropdown = ({ dashboards }) => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((open) => !open);

  return (
    <Dropdown
      id="views-dropdown"
      isOpen={dropdownOpen}
      toggle={toggle}
      className="flex-shrink-0 w-100"
    >
      <DarkerTextButton toggle size="sm" color="link" className="p-0">
        <div className="mr-1">Saved Views</div>
      </DarkerTextButton>
      <StyledMenu positionFixed right>
        {dashboards
          .filter((dashboard) => dashboard.name != null) // filter out the NEW_DASHBOARD
          .map(({ id, name, farmCount }) => {
            return (
              <DropdownItem
                key={id}
                onClick={() => navigate(`/app/dashboard/${id}`)}
              >
                <div
                  title={`${name}\n${farmCount} projects`}
                  className="text-truncate"
                >
                  {name}
                </div>
              </DropdownItem>
            );
          })}
      </StyledMenu>
    </Dropdown>
  );
};

export default DashboardViewsDropdown;
